import React, { useContext, useState } from 'react'
import ExcelModal from './modal'
import Button from '@mui/material/Button'
import { RiDownload2Line } from 'react-icons/ri'
import { Dayjs } from 'dayjs'
import { useUser } from '../../hooks/useUser'
import { UserRole } from '../../types/user'
import { AbilityContext } from '../Ability'

interface Props {
  onDownload?: (date: Dayjs) => void
  filterDate?: boolean
}

const ExportExcel = (props: Props) => {
  const { onDownload, filterDate = true } = props
  const { user } = useUser()
  const ability = useContext(AbilityContext)

  const [isOpen, setIsOpen] = useState<boolean>(false)

  const enableDownload =
    user?.roles?.includes(UserRole.ADMIN) ||
    user?.roles?.includes(UserRole.MERCHANT) ||
    ability.can('manage', 'setting', 'downloadExcel')

  const handleOnDownload = () => {
    setIsOpen(true)
  }

  if (!enableDownload) {
    return <></>
  }

  return (
    <>
      <ExcelModal
        onDownload={onDownload}
        isOpen={isOpen}
        filterDate={filterDate}
        onClose={(visible: boolean) => setIsOpen(visible)}
      />
      <Button
        color="info"
        size="large"
        fullWidth
        variant="contained"
        startIcon={<RiDownload2Line />}
        sx={{ height: '100%' }}
        onClick={() => handleOnDownload()}
      >
        ดาวน์โหลด
      </Button>
    </>
  )
}

export default ExportExcel
